// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.3.4_@swc+helpers@0.5.5__webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 *  This file is part of CoCalc: Copyright © 2020 Sagemath, Inc.
 *  License: MS-RSL – see LICENSE.md for details
 */

/*
CSS to handle tight/nontight lists.

ALSO, importantly, we handle the fact that lists in slate end up
getting entries somewhat renadomly wrapped in paragraphs or not.
When the markdown is loaded everything is wrapped in paragraphs;
however, when creating new lines, they might not be. We might
change/fix this, but in any case it's nice to be able to ensure
things don't look all wrong by getting rid of the paragraph margin
inside of lists. Also, eliminating this paragraph margin means we
don't have to compensate for it using negative margins.
*/

.cocalc-slate-tight-list  > li > p {
  margin-bottom: 0em;
}
.cocalc-slate-nontight-list > li >  p {
  margin-bottom: 0em;
}

.cocalc-slate-nontight-list > li {
  margin-bottom: 1em;
}

`, "",{"version":3,"sources":["webpack://./../frontend/editors/slate/elements/elements.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;;;;;;;;;;CAWC;;AAED;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/*\n *  This file is part of CoCalc: Copyright © 2020 Sagemath, Inc.\n *  License: MS-RSL – see LICENSE.md for details\n */\n\n/*\nCSS to handle tight/nontight lists.\n\nALSO, importantly, we handle the fact that lists in slate end up\ngetting entries somewhat renadomly wrapped in paragraphs or not.\nWhen the markdown is loaded everything is wrapped in paragraphs;\nhowever, when creating new lines, they might not be. We might\nchange/fix this, but in any case it's nice to be able to ensure\nthings don't look all wrong by getting rid of the paragraph margin\ninside of lists. Also, eliminating this paragraph margin means we\ndon't have to compensate for it using negative margins.\n*/\n\n.cocalc-slate-tight-list  > li > p {\n  margin-bottom: 0em;\n}\n.cocalc-slate-nontight-list > li >  p {\n  margin-bottom: 0em;\n}\n\n.cocalc-slate-nontight-list > li {\n  margin-bottom: 1em;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
